import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import { colors } from '../../../const/color';
import IconNonFilledStyled from '../icon-non-fill.styled';

const IconFirstAid: FC<IconProps> = ({ $size, ...rest }) => (
  <IconNonFilledStyled {...{ $size, ...rest }}>
    <svg xmlns="http://www.w3.org/2000/svg" width={'100%'} height={'100%'} viewBox="0 0 32 32" fill="none">
      <circle cx="16" cy="16" r="16" fill="white" />
      <path
        d="M26 5H6C5.44772 5 5 5.44772 5 6V26C5 26.5523 5.44772 27 6 27H26C26.5523 27 27 26.5523 27 26V6C27 5.44772 26.5523 5 26 5Z"
        stroke={colors[rest?.$color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M22 3V7" stroke={colors[rest?.$color]} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 3V7" stroke={colors[rest?.$color]} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5 11H27" stroke={colors[rest?.$color]} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M19.5 19H12.5"
        stroke={colors[rest?.$color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 15.5V22.5"
        stroke={colors[rest?.$color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </IconNonFilledStyled>
);

IconFirstAid.defaultProps = iconDefaultProps;
IconFirstAid.displayName = 'IconFirstAid';

export default IconFirstAid;
